import Axios from "axios";
import store from "../store";
import router from "../router";

let headers = {
    Accept: "application/json,image/jpeg,application/pdf"
};

const getBaseUrl = () => {
    let url = process.env.VUE_APP_BACK_API || "http://localhost:4445";
    if (typeof window !== "undefined" && window.location && window.location.hostname) {
        const hostname = window.location.hostname;
        if (hostname !== "localhost" && hostname !== "127.0.0.1") {
            url = url.replace("localhost", hostname).replace("127.0.0.1", hostname);
        }
    }
    return url;
};

const backApi = Axios.create({
    baseURL: getBaseUrl(),
    timeout: 99999,
    headers: headers
});

backApi.interceptors.response.use(
    response => {
        return response;
    },
    error => {

        if (error.response.status == 401) {
            store.dispatch("Login/logout").then(() => {});
            router.push("/login");
        } else {
            return Promise.reject(error.response.status);
        }
    }
);

export default {
    backApi: backApi
};
